import styled from 'styled-components';

export const ProfilePage = styled.main`
  width: min(calc(100% - 2rem), 72rem);
  margin: clamp(1rem, 3vw, 2.5rem) auto 6rem;

  @media (max-width: 56rem) {
    margin-bottom: calc(8rem + env(safe-area-inset-bottom));
  }

  @media (max-width: 40rem) {
    width: min(calc(100% - 1rem), 72rem);
  }
`;

export const ProfileHeader = styled.header`
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 1rem;
  margin-bottom: 1rem;
  padding: clamp(1rem, 2.5vw, 1.45rem);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xl);
  background: #fff;
  box-shadow: var(--shadow-xs);

  h1 { margin: 0; font-size: clamp(1.65rem, 4vw, 2.35rem); }
  p { display: none; }

  @media (max-width: 40rem) {
    align-items: flex-start;
    flex-direction: column;
  }
`;

export const Eyebrow = styled.div`
  display: none;
`;

export const ProfileGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(14rem, 18rem) minmax(0, 1fr);
  align-items: start;
  gap: 1.25rem;

  /* The first child is the profile/photo card on both profile pages. */
  > :first-child {
    position: sticky;
    top: 5.7rem;
    align-self: start;
    max-height: calc(100dvh - 6.5rem);
    overflow-y: auto;
    overscroll-behavior: contain;
    scrollbar-width: thin;
    scrollbar-gutter: stable;
  }

  > :first-child::-webkit-scrollbar {
    width: 6px;
  }

  > :first-child::-webkit-scrollbar-thumb {
    border-radius: 999px;
    background: rgba(17, 17, 17, 0.2);
  }

  @supports not (height: 100dvh) {
    > :first-child {
      max-height: calc(100vh - 6.5rem);
    }
  }

  @media (max-width: 56rem) {
    grid-template-columns: 1fr;

    > :first-child {
      position: static;
      max-height: none;
      overflow: visible;
    }
  }
`;

export const FormStack = styled.div`
  display: grid;
  align-self: start;
  gap: 1rem;
`;

export const SectionCard = styled.section`
  min-width: 0;
  padding: clamp(1rem, 2.5vw, 1.5rem);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xl);
  background: #fff;
  box-shadow: var(--shadow-xs);
`;

export const SectionHeader = styled.header`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: .85rem;
  padding-bottom: .75rem;
  border-bottom: 1px solid #eeebe6;

  h2 { margin: 0; font-size: 1.02rem; }
  p { display: none; }
`;

export const FieldGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: .15rem 1rem;

  @media (max-width: 38rem) {
    grid-template-columns: 1fr;
  }
`;

export const Full = styled.div`
  grid-column: 1 / -1;
`;

export const ActionBar = styled.div`
  position: fixed;
  z-index: 1250;
  left: calc(50% + 9.625rem);
  bottom: max(.8rem, env(safe-area-inset-bottom));
  width: min(calc(100% - 2rem), 52.75rem);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
  padding: .8rem;
  border: 1px solid rgba(0,0,0,.09);
  border-radius: 1.15rem;
  background: rgba(255,255,255,.96);
  box-shadow: 0 1rem 2.5rem rgba(0,0,0,.17);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
  pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')};
  transform: translate(-50%, ${({ $visible }) => ($visible ? '0' : '1rem')});
  transition: opacity 160ms ease, transform 160ms ease, visibility 160ms ease;

  > div:first-child { color: var(--color-muted); font-size: .76rem; }
  button { width: auto; min-width: 13rem; }

  @media (max-width: 56rem) {
    left: 50%;
    bottom: calc(4.65rem + env(safe-area-inset-bottom));
    width: min(calc(100% - 1rem), 42rem);
  }

  @media (max-width: 40rem) {
    gap: .65rem;
    padding: .65rem;
    > div:first-child span { display: none; }
    button { width: auto; min-width: 11rem; }
  }

  @media (max-width: 31rem) {
    > div:first-child { display: none; }
    button { width: 100%; min-width: 0; }
  }
`;

export const DangerCard = styled.section`
  padding: 1rem 1.2rem;
  border: 1px solid rgba(196,58,58,.25);
  border-radius: var(--radius-lg);
  background: rgba(196,58,58,.035);

  h2 { margin: 0; color: var(--color-errorRed); font-size: .95rem; }
  p { margin: .35rem 0 .8rem; color: var(--color-muted); font-size: .78rem; }
`;
